import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GeniLoader from './GeniLoader';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4 rounded-[28px] border border-white/10 bg-[radial-gradient(circle_at_top,_rgba(0,230,118,0.08),_transparent_38%),linear-gradient(180deg,rgba(255,255,255,0.03),rgba(255,255,255,0.015))] px-8 py-10 text-center">
          <GeniLoader size="md" />
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#9BFFBE]" data-testid="protected-route-loading-title">GENI Options</p>
          <p className="text-sm text-white/60" data-testid="protected-route-loading-copy">Validando acesso…</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  // Pass the current location in state AND as a query param for resilience
  if (!user) {
    const currentPath = location.pathname + location.search;
    const redirectParam = encodeURIComponent(currentPath);
    return (
      <Navigate 
        to={`/login?redirect=${redirectParam}`} 
        state={{ from: location }} 
        replace 
      />
    );
  }

  return children;
}
